
import React, {Component} from 'react'
import { render } from 'react-dom'
import { Provider, connect } from 'react-redux'
import WebpackerReact from 'webpacker-react';
import ProductOptionsRoot from './app/roots/product_options_root'
import TagInputter from './app/roots/tag_inputter'
import CollectionCriteria from './components/collection_criteria'
import CollectionSearchFields from './app/components/collection_search_fields'
import Turbolinks from 'turbolinks';

Turbolinks.start(); 
WebpackerReact.setup({ ProductOptionsRoot, TagInputter, CollectionCriteria, CollectionSearchFields });


import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

// Look for controllers inside app/javascripts/packs/controllers/
const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)

application.load(definitionsFromContext(context))


document.addEventListener('turbolinks:before-cache', () => WebpackerReact.unmountComponents());



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/index.js